<div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-6 gap-6 w-full min-w-0">


    <app-app-for-day-chart
            class="grid grid-cols-1 w-full col-span-2 md:col-span-6 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden"
            [generalData]="generalData"
            [appForDay]="appForDay"></app-app-for-day-chart>


<!--    <app-app-for-day-chart-->
<!--            style="background: #2196f329 !important"-->
<!--            class="grid grid-cols-1 w-full col-span-2 md:col-span-6 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden"-->
<!--            [generalData]="generalDataNext"-->
<!--            [titleText]="'Prossime Application/giorno'"-->
<!--            [appForDay]="appForDayNext"></app-app-for-day-chart>-->

    <div class="grid grid-cols-1 md:grid-cols-3 col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8">

        <app-ssdf-application-batch-chart
                [title]="'AI/CYBERSECURITY'"
                [color]="'rgb(220, 38, 38)'"
                [textColor]="'text-red-500'"
                [numberColor]="'text-red-600'"
                [series]="batchData?.ai.series"
                [labels]="batchData?.ai.labels"
                [appNumber]="batchData?.ai?.appNumber"
                [difference]="batchData?.ai?.percentageChangeNumber"

        ></app-ssdf-application-batch-chart>

        <app-ssdf-application-batch-chart
                [title]="'AEROSPACE'"
                [color]="'rgb(37, 99, 235)'"
                [textColor]="'text-blue-500'"
                [numberColor]="'text-blue-600'"
                [series]="batchData?.aerospace.series"
                [labels]="batchData?.aerospace.labels"
                [appNumber]="batchData?.aerospace?.appNumber"
                [difference]="batchData?.aerospace?.percentageChangeNumber"

        ></app-ssdf-application-batch-chart>


        <app-ssdf-application-batch-chart
                [title]="'CLIMATE TECH'"
                [color]="'rgb(13, 148, 136)'"
                [textColor]="'text-teal-500'"
                [numberColor]="'text-teal-600'"
                [series]="batchData?.climate.series"
                [labels]="batchData?.climate.labels"
                [appNumber]="batchData?.climate?.appNumber"
                [difference]="batchData?.climate?.percentageChangeNumber"

        ></app-ssdf-application-batch-chart>

    </div>
    <!-- Features -->

    <div class="grid grid-cols-1 md:grid-cols-3  col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8">


        <app-ssdf-application-batch-chart
                [title]="'ADV. MANUFACTURING'"
                [color]="'rgb(22, 163, 74)'"
                [textColor]="'text-green-500'"
                [numberColor]="'text-green-600'"
                [series]="batchData?.adMan.series"
                [labels]="batchData?.adMan.labels"
                [appNumber]="batchData?.adMan?.appNumber"
                [difference]="batchData?.adMan?.percentageChangeNumber"

        ></app-ssdf-application-batch-chart>


        <app-ssdf-application-batch-chart
                [title]="'MEDTECH/LIFE SCIENCE'"
                [color]="'rgb(217, 119, 6)'"
                [textColor]="'text-amber-500'"
                [numberColor]="'text-amber-600'"
                [series]="batchData?.biotech.series"
                [labels]="batchData?.biotech.labels"
                [appNumber]="batchData?.biotech?.appNumber"
                [difference]="batchData?.biotech?.percentageChangeNumber"

        ></app-ssdf-application-batch-chart>


        <app-ssdf-application-batch-chart
                [title]="'QUANTUM TECHNOLOGIES'"
                [color]="'rgb(71,85,105)'"
                [textColor]="'text-accent-500'"
                [numberColor]="'text-accent-600'"
                [series]="batchData?.quantum.series"
                [labels]="batchData?.quantum.labels"
                [appNumber]="batchData?.quantum?.appNumber"
                [difference]="batchData?.quantum?.percentageChangeNumber"
        ></app-ssdf-application-batch-chart>


    </div>


    <app-app-for-day-batch-chart
            class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8"
            [batchData]="batchData"
            [appForDay]="appForDay"></app-app-for-day-batch-chart>


    <app-app-for-day-batch-heatmap
            class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8"
            [batchData]="batchData"
            [appForDay]="appForDay"></app-app-for-day-batch-heatmap>


    <app-app-for-batch-pie-chart
            class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8"
            [batchData]="batchData"
    ></app-app-for-batch-pie-chart>

    <div class="grid grid-cols-1 md:grid-cols-3 col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8">
        <!-- New vs. Returning -->

        <app-app-formed-company-pie-chart
                class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                [formedCompanyData]="formedCompanyData"
        ></app-app-formed-company-pie-chart>

        <!-- Gender -->


        <app-app-patents-pie-chart
                class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                [patentsData]="patentsData"
        ></app-app-patents-pie-chart>


        <app-app-lab-needed-pie-chart
                class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                [labNeededData]="labNeededData"
        ></app-app-lab-needed-pie-chart>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8">


        <app-app-funding-need-pie-chart
                class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                [fundingNeedPieData]="fundingNeedPieData"
        ></app-app-funding-need-pie-chart>


        <app-app-origination-pie-chart
                class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                [originationData]="originationData"
                [applicationList]="applicationList"
        ></app-app-origination-pie-chart>


    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8">

        <!--        <app-app-region-pie-chart-->
        <!--                class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"-->
        <!--[regionData]="appForRegion"-->
        <!--        >-->

        <!--        </app-app-region-pie-chart>-->


        <app-app-country-pie-chart
                class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                [countryData]="countryData"
        ></app-app-country-pie-chart>

        <app-app-area-pie-chart
                class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                [zoneData]="zoneData"
        ></app-app-area-pie-chart>

    </div>

    <app-app-trl-bar-chart
            class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8"
            [appForTrl]="appForTrl"
    >
    </app-app-trl-bar-chart>


    <app-app-for-region-bar-chart
            class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8"
            [appForRegion]="appForRegion"
    ></app-app-for-region-bar-chart>


    <app-app-region-batch-bar-chart
            class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8"
            [appForRegion]="appForRegion"
    ></app-app-region-batch-bar-chart>


    <app-app-batch-funding-need-bar-chart
            class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8"
            [fundingNeedBarData]="fundingNeedBarData"
    >

    </app-app-batch-funding-need-bar-chart>


    <app-val-premoney-day-area-chart
            class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-0"
            [appForPremoney]="appForPremoney"
    >

    </app-val-premoney-day-area-chart>


    <app-val-premoney-batch-bar-chart
            class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8"
            [appForPremoney]="appForPremoney">

    </app-val-premoney-batch-bar-chart>


    <!--                        <app-val-premoney-batch-radar-chart-->
    <!--                                class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8"-->
    <!--                                [appForPremoney]="appForPremoney"-->
    <!--                        >-->
    <!--                        </app-val-premoney-batch-radar-chart>-->


    <div class="col-span-2 md:col-span-6 flex flex-col w-full bg-card shadow rounded-2xl p-4">

        <div class="flex items-start justify-between">
            <div class="text-xl font-medium tracking-tight leading-6 truncate">Val. media premoney/giorno
            </div>
        </div>


        <div class="grid grid-cols-1 md:grid-cols-2 col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8">
            <!-- Weekly expenses -->

            <app-val-premoney-for-day-batch-card
                    class="flex flex-col flex-auto p-6 shadow rounded-2xl overflow-hidden"
                    [batch]="'AI/CYBERSECURITY'"
                    [color]="'rgb(220, 38, 38)'"

                    [data]="appForPremoney?.batchDetail?.ai"

                    [style.background-color]="'rgba(220, 38, 38, 0.2)'"

            ></app-val-premoney-for-day-batch-card>

            <app-val-premoney-for-day-batch-card
                    class="flex flex-col flex-auto p-6  shadow rounded-2xl overflow-hidden"
                    [batch]="'AEROSPACE'"
                    [color]="'rgb(37, 99, 235)'"
                    [style.background-color]="'rgba(37, 99, 235, 0.2)'"
                    [data]="appForPremoney?.batchDetail?.aerospace"
            ></app-val-premoney-for-day-batch-card>

        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8">
            <!-- Weekly expenses -->
            <app-val-premoney-for-day-batch-card
                    class="flex flex-col flex-auto p-6  shadow rounded-2xl overflow-hidden"
                    [batch]="'CLIMATE TECH'"
                    [color]="'rgb(13, 148, 136)'"
                    [style.background-color]="'rgba(13, 148, 136, 0.2)'"

                    [data]="appForPremoney?.batchDetail?.climate"
            ></app-val-premoney-for-day-batch-card>

            <app-val-premoney-for-day-batch-card
                    class="flex flex-col flex-auto p-6  shadow rounded-2xl overflow-hidden"
                    [batch]="'ADV. MANUFACTURING'"
                    [color]="'rgb(22, 163, 74)'"
                    [style.background-color]="'rgba(22, 163, 74, 0.2)'"

                    [data]="appForPremoney?.batchDetail?.adMan"
            ></app-val-premoney-for-day-batch-card>


        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8">
            <!-- Weekly expenses -->


            <app-val-premoney-for-day-batch-card
                    class="flex flex-col flex-auto p-6  shadow rounded-2xl overflow-hidden"
                    [batch]="'MEDTECH/LIFE SCIENCE'"
                    [color]="'rgb(217, 119, 6)'"
                    [style.background-color]="'rgba(217, 119, 6, 0.2)'"

                    [data]="appForPremoney?.batchDetail?.biotech"
            ></app-val-premoney-for-day-batch-card>

            <app-val-premoney-for-day-batch-card
                    class="flex flex-col flex-auto p-6  shadow rounded-2xl overflow-hidden"
                    [batch]="'QUANTUM TECHNOLOGIES'"
                    [color]="'rgb(71,85,105)'"
                    [style.background-color]="'rgba(71,85,105, 0.2)'"
                    [data]="appForPremoney?.batchDetail?.quantum"
            ></app-val-premoney-for-day-batch-card>
        </div>

    </div>

</div>
